import { Box, Button, Grid, Typography } from '@material-ui/core';
import { FC } from 'react';

interface ToolbarProps {
  selectedCount?: number;
  onOpenFollowUpModal: () => void;
  onOpenRejectModal: () => void;
}

const CustomToolbarSelect: FC<ToolbarProps> = ({ selectedCount, onOpenFollowUpModal, onOpenRejectModal }) => {
  return (
    <Grid item>
      <Box display="flex" flexDirection="column">
        <Box marginLeft={3}>
          <Typography variant="caption">{selectedCount} applications selected</Typography>
        </Box>
        <Button style={{ marginRight: 10 }} onClick={onOpenFollowUpModal} color="primary" variant="contained">
          Request additional details
        </Button>
        <Button onClick={onOpenRejectModal} color="primary" variant="contained">
          Reject application
        </Button>
      </Box>
    </Grid>
  );
};

export default CustomToolbarSelect;
